/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesSubscriptionPlansDtosPublicSubscriptionPlanDto
} from '.././models';

import { publicCustomInstance } from '../../mutator/public-custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getPublicPlans = () => {
const getApiV1PublicSubscriptionPlans = (
    
 options?: SecondParameter<typeof publicCustomInstance<FacilityFlowCoreModulesSubscriptionPlansDtosPublicSubscriptionPlanDto[]>>,) => {
      return publicCustomInstance<FacilityFlowCoreModulesSubscriptionPlansDtosPublicSubscriptionPlanDto[]>(
      {url: `/api/v1/public/subscription-plans`, method: 'GET'
    },
      options);
    }
  return {getApiV1PublicSubscriptionPlans}};
export type GetApiV1PublicSubscriptionPlansResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPublicPlans>['getApiV1PublicSubscriptionPlans']>>>
